import { render, staticRenderFns } from "./Shareequpt.vue?vue&type=template&id=5a5bb772&scoped=true"
import script from "./Shareequpt.vue?vue&type=script&lang=js"
export * from "./Shareequpt.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a5bb772",
  null
  
)

export default component.exports